export const environment = {
  production: false,
  TENANT_ID: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com',
  CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
  REDIRECT_URL: 'https://sit.lios.toyota.com',
  SCOPES: ['https://tmnatest.onmicrosoft.com/e45b42dc-670d-4640-b95b-a24d12e73448/user_impersonation'],
  CLOUDFRONT: 'https://d1i2ve6o7227y8.cloudfront.net',
  log_level: 'debug',
  ADMIN_DS_URI: 'https://api.sit.lios.toyota.com/admin/graphql',
  APM_DS_URI: 'https://api.sit.lios.toyota.com/apm/graphql',
  BILLING_DS_URI: 'https://api.sit.lios.toyota.com/billing/graphql',
  OPERATION_DS_URI : "https://api.sit.lios.toyota.com/operations/graphql",
  MAINTENANCE_DS_URI : "https://api.sit.lios.toyota.com/maintenance/graphql",
  FILEDOWNLOAD_PDF_URI : "https://filedownload.sit.lios.toyota.com",
  manifest: {
    admin: 'https://admin.sit.lios.toyota.com/remoteEntry.js',
    apm: 'https://apm.sit.lios.toyota.com/remoteEntry.js',
    bm: 'https://bm.sit.lios.toyota.com/remoteEntry.js',
    lcm: 'https://lcm.sit.lios.toyota.com/remoteEntry.js',
    cm: 'https://cm.sit.lios.toyota.com/remoteEntry.js',
    drc: 'https://drc.sit.lios.toyota.com/remoteEntry.js',
    gc: 'https://generalcosts.sit.lios.toyota.com/remoteEntry.js',
    ec: 'https://ec.sit.lios.toyota.com/remoteEntry.js',
    lpi: 'https://lpi.sit.lios.toyota.com/remoteEntry.js',
    maintenance: 'https://maintenance.sit.lios.toyota.com/remoteEntry.js',
    mshell: 'https://mshell.sit.lios.toyota.com/remoteEntry.js',
    bshell: 'https://bshell.sit.lios.toyota.com/remoteEntry.js',
    opershell : 'https://opershell.sit.lios.toyota.com/remoteEntry.js',
    operations : 'https://operations.sit.lios.toyota.com/remoteEntry.js'
  },
  
  TASK_MANAGER: 'https://liosapps.qa.toyota.com/task',
  AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
  ALARMS: 'https://liosapps.qa.toyota.com/alarms',
  FORECAST_ADMIN_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/forecast',
  CO2: 'https://liosapps.qa.toyota.com/co2/lp-upload',
  COST_PLANNING: 'https://liosapps.qa.toyota.com/costplanning/',
  EBOI: 'https://liosapps.qa.toyota.com/eboi',
  TLD: 'https://liosapps.qa.toyota.com/tld/home',
  DD: 'https://ts.stage.portal.toyotasupplier.com/lios/delayindex#/delayeddispatch',
  REPORTS: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=11db23f6-28df-4b47-bf4d-03bb6cab9246&ctid=8c642d1d-d709-47b0-ab10-080af10798fb&experience=power-bi',
  EXPORT: 'https://liosapps.qa.toyota.com/export',
  GROUPI: 'https://liosapps.qa.toyota.com/groupi',
  SCHEDULE_JOB: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  RETURNS_RELOAD: 'https://ts.stage.portal.toyotasupplier.com/lios/routemgt',
  SCHEDULE_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  TLMS_SEND: 'https://ts.stage.portal.toyotasupplier.com/lios/tlmssend',
  ALLO: 'https://ts.stage.portal.toyotasupplier.com/lios/alloindex#/alloextracts',
  TEMPLATE_URI: "https://template.sit.lios.toyota.com"
};
